import './bogusbasin/style';
import FormStructure from './bogusbasin/form_structure';

export default FormStructure;